import { hbs } from 'ember-cli-htmlbars';
import { userChangePhoneNumberAction, userClickEnrollAction } from '@banking/ui/workflows/common/two-factor';
import { workflowComponent } from '@banking/ui/services/card-management/cancel-card-modal';
const template = hbs`
  <Banking::TwoFactor::PhoneNumber
    @initialValue={{this.initialValue}}
    @errorMessage={{this.errorMessage}}
    @isButtonLoading={{this.isButtonLoading}}
    @onValueChange={{this.onValueChange}}
    @onNextButtonClick={{this.onNextButtonClick}}
  />`;
const mapStateToProps = state => {
  const twoFactorState = state.twoFactor;
  return {
    initialValue: twoFactorState.phoneNumber,
    // default to null because market-field will show error with empty string error message
    errorMessage: twoFactorState.phoneNumberError || null,
    isButtonLoading: twoFactorState.toggleButtonLoading
  };
};
const mapActionsToProps = () => ({
  onValueChange: userChangePhoneNumberAction,
  onNextButtonClick: userClickEnrollAction
});
export default workflowComponent(mapStateToProps, mapActionsToProps)(template);